var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "container mt-5"
  }, [!_vm.staff ? _c('div', {
    staticClass: "p-3",
    attrs: {
      "id": "step1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "text-center mt-2"
  }, [_c('h1', {
    staticClass: "h5 font-weight-bold"
  }, [_vm._v("啟用帳號")])]), _c('div', {
    staticClass: "text-center mt-3 mb-5"
  }, [_c('h5', [_vm._v("請填寫您的資料")])]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("員工編號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.employeeCode,
      expression: "employeeCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入您的員工編號"
    },
    domProps: {
      "value": _vm.employeeCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.employeeCode = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-mail")]), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "form-control col-6",
    attrs: {
      "type": "text",
      "placeholder": "請輸入您的 E-mail"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "email-input-extra col-6"
  }, [_c('span', [_vm._v("@chailease.com.tw")])])])]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "outline-dark mr-3 w-100",
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _c('b-button', {
    attrs: {
      "size": "lg",
      "variant": "primary w-100",
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("送出")])], 1)], 1)], 1) : _vm._e(), _vm.staff ? _c('div', {
    staticClass: "p-3",
    attrs: {
      "id": "step2"
    }
  }, [_c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.getAvatar,
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('div', {
    staticClass: "text-center font-weight-bolder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.staff.name))]), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.staff.job_level)), _c('br'), _vm._v(" " + _vm._s(_vm.staff.service_unit) + " ")])])]), _vm.staff ? _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('h5', [_vm._v("帳號綁定成功")])]) : _vm._e(), _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "mb-1 mt-3",
    attrs: {
      "variant": "success",
      "size": "lg"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 回官方帳號 ")])], 1)], 1) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }